import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-13877386");

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sidebar = _resolveComponent("sidebar");

  var _component_app_main = _resolveComponent("app-main");

  var _component_navbar = _resolveComponent("navbar");

  return _openBlock(), _createBlock("div", {
    class: ['app-wrapper', _ctx.sidebar.opened ? 'openSidebar' : 'hideSidebar', _ctx.sidebar.withoutAnimation ? 'withoutAnimation' : '', $setup.device == 'mobile' ? 'mobile' : '']
  }, [$setup.device == 'mobile' && _ctx.sidebar.opened ? (_openBlock(), _createBlock("div", {
    key: 0,
    class: "drawer-bg",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.handleClickOutside && $setup.handleClickOutside.apply($setup, arguments);
    })
  })) : _createCommentVNode("v-if", true), _createVNode(_component_sidebar, {
    class: "sidebar-container"
  }), _createVNode("div", {
    class: [{
      hasTagsView: $setup.needTagsView
    }, "main-container"]
  }, [_createVNode(_component_app_main)], 2
  /* CLASS */
  ), _createVNode("div", {
    class: {
      'fixed-header': $setup.fixedHeader
    }
  }, [_createVNode(_component_navbar), _createCommentVNode(" <tags-view v-if=\"needTagsView\" /> ")], 2
  /* CLASS */
  )], 2
  /* CLASS */
  );
});